import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenlayersComponent } from './simple-icons-openlayers.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenlayersComponent ],
    exports:      [ SimpleIconsOpenlayersComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenlayersModule {}
